import { CUSTOM_MODEL } from '../ai-agents/proxy/ai-agents.consts';
import { LlmConfigurationProvider } from '../integrations/proxy/integration.model';

export const TOOLTIP_DELAY = 400;

export const FONT_FAMILY_NUNITO_SANS = 'Nunito Sans';

export const FILTER_PANEL_NAMES = {
  dashboard: 'Dashboard',
  conversations: 'Conversations',
  generativeQuestionAnsweringRecognitions: 'GenerativeQuestionAnsweringRecognitions',
  outboundRequests: 'OutboundRequests',
  callRequests: 'CallRequests',
  callAttempts: 'CallAttempts',
};

export const FILE_SIZES = {
  bytes: 'Bytes',
  kb: 'KB',
  mb: 'MB',
  gb: 'GB',
  tb: 'TB',
};

export const ID_LIST_OF_CONVERSATIONS_ON_CURRENT_PAGE_CACHE_KEY = 'conversationsCurrentPageIdList';

export const DESIGNER_FLOW_LINK_NAMES_VISIBLE_CACHE_KEY = 'linkNamesVisible';

export const PROJECT_CREATION_SESSION_KEY = 'projectCreation';

export const PROJECT_CREATION_VA_INDEX_SESSION_KEY = 'projectCreationVaIndex';

export const COLUMN_CONFIGURATOR_KEY = 'columnConfigurator';

export const PROJECT_FLOWS_AND_VIRTUAL_AGENTS_KEY = 'projectFlowsAndVirtualAgents';

export const OUTBOUND_TEST_CALL_PARAMETERS_KEY = 'outboundTestCallParameters';

export const TEST_CHAT_SETTINGS_KEY = 'testChatSettings_';

export const PROJECT_VIRTUAL_AGENT_INTENT_GROUP_KEY = 'selectedProjectVirtualAgentAndIntentGroups';

export const TOASTER_LIFE = 5000;

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const PRODUCT_VERSION_APP_NAME = 'cai-magpie-api';

export const NOT_AVAILABLE = 'N/A';

export const ARABIC_LANGUAGE_CODE = 'ar-SA';

export const FLOW_VERSION_CANNOT_BE_UPDATED_ERROR_CODE = 'Raven:0100148';

export const NLU_INTEGRATION_ERROR_CODE = 'Raven:0100117';

export const COMMA_KEY_CODE = 188;
export const TAB_KEY_CODE = 9;
export const ENTER_KEY_CODE = 13;

export const LLM_MODELS = new Map<LlmConfigurationProvider, string[]>([
  [
    LlmConfigurationProvider.openAi,
    [
      'gpt-4o',
      'gpt-4o-mini',
      'o3-mini',
      'chatgpt-4o-latest',
      'gpt-4.1',
      'gpt-4.1-mini',
      'gpt-4.1-nano',
      'o3',
      'o4-mini',
      CUSTOM_MODEL,
    ],
  ],
  [LlmConfigurationProvider.azureOpenAi, []],
  [
    LlmConfigurationProvider.awsBedrock,
    [
      'anthropic.claude-3-7-sonnet-20250219-v1:0',
      'anthropic.claude-3-5-sonnet-20241022-v2:0',
      'anthropic.claude-3-5-haiku-20241022-v1:0',
      'anthropic.claude-3-opus-20240229-v1:0',
      'meta.llama3-3-70b-instruct-v1:0',
      'meta.llama3-2-90b-instruct-v1:0',
      'meta.llama3-2-11b-instruct-v1:0',
      'meta.llama3-2-3b-instruct-v1:0',
      'meta.llama3-2-1b-instruct-v1:0',
      'meta.llama3-1-405b-instruct-v1:0',
      'meta.llama3-1-8b-instruct-v1:0',
      CUSTOM_MODEL,
    ],
  ],
  [
    LlmConfigurationProvider.googleGemini,
    [
      'gemini-2.0-flash',
      'gemini-2.0-flash-lite',
      'gemini-2.5-pro-preview-03-25',
      'gemini-2.5-flash-preview-04-17',
      CUSTOM_MODEL,
    ],
  ],
  [LlmConfigurationProvider.sestek, [CUSTOM_MODEL]],
  [
    LlmConfigurationProvider.groq,
    [
      'qwen-2.5-32b',
      'deepseek-r1-distill-llama-70b',
      'deepseek-r1-distill-llama-70b-specdec',
      'deepseek-r1-distill-qwen-32b',
      'gemma2-9b-it',
      'llama-3.3-70b-versatile',
      'llama-3.3-70b-specdec',
      'llama-3.2-90b-vision-preview',
      'llama-3.2-11b-vision-preview',
      'llama-3.2-3b-preview',
      'llama-3.2-1b-preview',
      'llama-3.1-8b-instant',
      'llama3-70b-8192',
      'llama3-8b-8192',
      'llama-guard-3-8b',
      'mixtral-8x7b-32768',
      CUSTOM_MODEL,
    ],
  ],
  [
    LlmConfigurationProvider.togetherAi,
    [
      'deepseek-ai/DeepSeek-R1',
      'deepseek-ai/DeepSeek-V3',
      'deepseek-ai/deepseek-llm-67b-chat',
      'deepseek-ai/DeepSeek-R1-Distill-Llama-70B',
      'deepseek-ai/DeepSeek-R1-Distill-Qwen-14B',
      'deepseek-ai/DeepSeek-R1-Distill-Qwen-1.5B',
      'google/gemma-2-27b-it',
      'google/gemma-2-9b-it',
      'Qwen/Qwen2.5-72B-Instruct-Turbo',
      'Qwen/Qwen2.5-7B-Instruct-Turbo',
      'Qwen/Qwen2.5-Coder-32B-Instruct',
      'meta-llama/Llama-3.3-70B-Instruct-Turbo',
      'meta-llama/Llama-3.2-90B-Vision-Instruct-Turbo',
      'meta-llama/Llama-3.2-11B-Vision-Instruct-Turbo',
      'meta-llama/Llama-3.2-3B-Instruct-Turbo',
      'meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo',
      'meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo-128K',
      'meta-llama/Llama-Guard-3-11B-Vision-Turbo',
      'meta-llama/Meta-Llama-Guard-3-8B',
      CUSTOM_MODEL,
    ],
  ],
  [LlmConfigurationProvider.vertexAi, ['gemini-2.5-pro', 'gemini-2.5-flash', CUSTOM_MODEL]],
]);
